<glxy-page>
  <glxy-empty-state class="empty-state-container">
    <glxy-empty-state-hero>
      <img
        src="https://storage.googleapis.com/galaxy-libs-public-images/crm/permission-required.svg"
        [alt]="'PERMISSIONS.IMAGE_ALT' | translate"
      />
    </glxy-empty-state-hero>
    <glxy-empty-state-title>{{ 'PERMISSION.TITLE' | translate }}</glxy-empty-state-title>
    <p>
      {{ 'PERMISSION.DESCRIPTION' | translate }}
    </p>
    <p>
      {{ 'PERMISSION.REQUEST_ACCESS' | translate }}
    </p>
  </glxy-empty-state>
</glxy-page>
